import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import styleClasses from '../css/mobile/CardList.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

const CardList = ({ cards }) => {
    const [filter, setFilter] = useState([]);
    const [name, setName] = useState('');
    const [filteredCards, setFilteredCards] = useState(cards);
    const [totalCount, setTotalCount] = useState(cards.length);
    const [openPopup, setOpenPopup] = useState(false);
    const [openGenreTag, setOpenGenreTag] = useState(false);
    const [openPositionTag, setOpenPositionTag] = useState(false);
    const [seletedGenreCount, setSeletedGenreCount] = useState(0);
    const [seletedPositionCount, setSeletedPositionCount] = useState(0);

    useEffect(() => {
        let updatedCards = cards;

        if (filter.length) {
            updatedCards = updatedCards.filter( (card) =>
                card.genres.some((genre) => filter.includes(genre)) ||
                card.positions.some((position) => filter.includes(position))
            );
        }

        if (name !== '') {
            const lowerName = name.toLowerCase();
            updatedCards = updatedCards.filter((card) =>
                card.title.toLowerCase().includes(lowerName)
            );
        }

        setFilteredCards(updatedCards);
        setTotalCount(updatedCards.length);

        const selectedGenre     = document.querySelectorAll(`.${ styleClasses.genreTags } .${ styleClasses.active }`);
        const selectedPosition  = document.querySelectorAll(`.${ styleClasses.positionTags } .${ styleClasses.active }`);

        setSeletedGenreCount(selectedGenre.length);
        setSeletedPositionCount(selectedPosition.length);
    }, [cards, filter, name]);
  
    const handleFilter = (tag) => {
        if (filter.includes(tag)) {
            setFilter(filter.filter(item => item !== tag));
        } else {
            setFilter([...filter, tag]);
        }
    };

    const resetGenreFilter = () => {
        const genreFilters = document.querySelectorAll(`.${ styleClasses.genreTags } .${ styleClasses.active }`);
        
        if (genreFilters.length) {
            for (let item of genreFilters) {
                setTimeout(() =>{ item.click(); }, 0);
            }
        }
    }

    const resetPositionFilter = () => {
        const positionFilters = document.querySelectorAll(`.${ styleClasses.positionTags } .${ styleClasses.active }`);
        
        if (positionFilters.length) {
            for (let item of positionFilters) {
                setTimeout(() =>{ item.click(); }, 0);
            }
        }
    }

    return (
        <>
            <div className={ styleClasses.searchSectionMobile }>
                {/* <h3>Musician</h3> */}
                <div className={ styleClasses.searchField }>
                    <input type="text" onKeyUp={ (event) => setName(event.target.value) } placeholder='Musician' />
                </div>
            </div>

            {/* 태그 */}
            <div className={ styleClasses.tagSectionMobile }>
                <div className={ styleClasses.tags }>
                    {/* 장르 태그 */}
                    <h3 onClick={ () => { setOpenPopup(true); setOpenGenreTag(true); } }>
                        Genre
                        {
                            seletedGenreCount > 0 && (<span>{ seletedGenreCount }</span> )
                        }
                        <i className={ styleClasses.plusIcon }></i>
                    </h3>    
                    <div className={`${ styleClasses.tagPopup } ${ openGenreTag && styleClasses.active }`}>
                        <div className={ styleClasses.popupHeader }>
                            <h3 className={ styleClasses.tagTitle }>
                                Genre
                                {
                                    seletedGenreCount > 0 &&
                                    (
                                        <div onClick={ resetGenreFilter }>
                                            <i className={ styleClasses.resetIcon }></i>
                                        </div>
                                    )
                                }
                            </h3>
                            <p>Total { totalCount } Results </p>
                            <button onClick={ () => { setOpenPopup(false); setOpenGenreTag(false); } }>
                                <i className={ styleClasses.closeIcon }></i>
                            </button>
                        </div>
                        <div className={ styleClasses.genreTags }>
                        {
                            Array.from(new Set(cards.flatMap((card) => card.genres))).map((genre) => (
                                <button key={`genre-${ genre }`} className={`${ styleClasses.tag } ${ styleClasses.genreTag } ${ filter.includes(genre) ? styleClasses.active : '' }`} onClick={ () => handleFilter(genre) }>
                                    { genre }
                                </button>
                            ))
                        }
                        </div>
                    </div>
                    
                    {/* 포지션 태그 */}
                    <h3 onClick={ () => { setOpenPopup(true); setOpenPositionTag(true); } }>
                        Position
                        {
                            seletedPositionCount > 0 && (<span>{ seletedPositionCount }</span> )
                        }
                        <i className={ styleClasses.plusIcon }></i>
                    </h3>
                    <div className={`${ styleClasses.tagPopup } ${ openPositionTag && styleClasses.active }`}>
                        <div className={ styleClasses.popupHeader }>
                            <h3 className={ styleClasses.tagTitle }>
                                Position
                                {
                                    seletedPositionCount > 0 &&
                                    (
                                        <div onClick={ resetPositionFilter }>
                                            <i className={ styleClasses.resetIcon }></i>
                                        </div>
                                    )
                                }
                            </h3>
                            <p>Total { totalCount } Results </p>
                            <button onClick={ () => { setOpenPopup(false); setOpenPositionTag(false); } }>
                                <i className={ styleClasses.closeIcon }></i>
                            </button>
                        </div>
                        <div className={ styleClasses.positionTags }>
                        {
                            Array.from(new Set(cards.flatMap((card) => card.positions))).map((position) => (
                                <button key={`position-${ position }`} className={`${ styleClasses.tag } ${ styleClasses.positionTag } ${ filter.includes(position) ? styleClasses.active : '' }`} onClick={ () => handleFilter(position) } >
                                    { position }
                                </button>
                            ))
                        }
                        </div>
                    </div>
                </div>
            </div>

            {/* 목록 */}
            <div className={ styleClasses.musicianList }>
                <div className={ styleClasses.inner }>
                {
                    filteredCards.map((card, index) => (
                        <Link key={ index } to={`/musicard/${ card.id }`} className={ styleClasses.card }>
                            <LazyLoad width='100%' height='100%' offset={ 480 }>
                                <LazyLoadImage src={ card.image } alt={ card.title } className={ styleClasses.cardImage } effect='blur' width='100%' height='100%'/>
                            </LazyLoad>
                            <div className={ styleClasses.cardContent }>
                                <h3 className={ styleClasses.cardTitle }>{ card.title }</h3>
                                <div className={ styleClasses.tags }>
                                    <div className={ styleClasses.genreTags }>
                                    {/* 장르 태그 */}
                                    {
                                        card.genres.map((genre, idx) => (
                                            idx < 5 &&
                                            <span key={`genre-${ idx }`} className={ styleClasses.tag }>{ genre }</span>
                                        ))
                                    }
                                    </div>
                                    {/* 장르가 5개가 넘을 경우 */}
                                    {
                                        card.genres.length > 4 && (
                                            <div className={ styleClasses.genreTags }>
                                            {/* 장르 태그 */}
                                            {
                                                card.genres.map((genre, idx) => (
                                                idx > 4 && 
                                                        <span key={`genre-${ idx }`} className={ styleClasses.tag }>{ genre }</span>
                                                    )
                                                )
                                            }
                                            </div>
                                        )
                                    }
                                    <div className={ styleClasses.positionTags }>
                                    {/* 포지션 태그 */}
                                    {
                                        card.positions.map((position, idx) => (
                                            idx < 5 &&
                                            <span key={`position-${ idx }`} className={ styleClasses.tag }>{ position }</span>
                                        ))
                                    }
                                    </div>
                                    {/* 포지션이 5개가 넘을 경우 */}
                                    {
                                        card.positions.length > 4 && 
                                        (
                                            <div className={ styleClasses.positionTags }>
                                                {
                                                card.positions.map((position, idx) => (
                                                    idx > 4 &&
                                                    <span key={`position-${ idx }`} className={ styleClasses.tag }>{ position }</span>
                                                ))
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </Link>
                    ))
                }
                </div>
            </div>

            {
                openPopup && (
                    <div
                        className={ styleClasses.backDrop }
                        onClick={ () => { setOpenPopup(false); setOpenGenreTag(false); setOpenPositionTag(false); } }>
                    </div>
                )
            }
            
        </>
    );
};

export default CardList;
